import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import styles from './Withdraw.module.sass'
import { fetchWallets } from 'store/actions'
import ConfirmWithdrawModal from './ConfirmWithdrawModal'
import SecurityAuthModal from './SecurityAuthModal'
import { sendWithdrawalEmailPinAPI, withdrawalEmailVerifyPinAPI } from 'apis/withdraw'

const networks = [
  {
    id: 'trc20',
    name: 'TRC20',
    chain: 'Tron',
    fee: '1.5 USDT',
    minimum: '1 USDT',
    arrival: '~ 3 min',
  },
  {
    id: 'erc20',
    name: 'ERC20',
    chain: 'Ethereum',
    fee: '2.204731 USDT (~ 2.20 USD)',
    minimum: '1 USDT',
    arrival: '~ 3 min',
  },
  {
    id: 'solana',
    name: 'SOLANA',
    chain: '',
    fee: '0.8358 USDT (~ 0.83 USD)',
    minimum: '2 USDT',
    arrival: '~ 3 min',
  },
  {
    id: 'bep20',
    name: 'BEP20',
    chain: 'BNB Smart Chain',
    fee: '1.5 USDT (~ 1.50 USD)',
    minimum: '1 USDT',
    arrival: '~ 3 min',
  },
  {
    id: 'apt',
    name: 'APT',
    chain: 'Aptos',
    fee: '0 USDT Free',
    minimum: '10 USDT',
    arrival: '~ 2 min',
  },
  {
    id: 'avax',
    name: 'AVAXCCHAIN',
    chain: '',
    fee: '0.6 USDT (~ 0.60 USD)',
    minimum: '1 USDT',
    arrival: '~ 2 min',
  },
  {
    id: 'near',
    name: 'NEAR',
    chain: 'NEAR Protocol',
    fee: '0.3 USDT (~ 0.30 USD)',
    minimum: '1 USDT',
    arrival: '~ 2 min',
  },
  {
    id: 'celo',
    name: 'CELO',
    chain: '',
    fee: '0.03 USDT (~ 0.030 USD)',
    minimum: '10 USDT',
    arrival: '~ 2 min',
  },
]

const notes = [
  'We recommend enabling Express Withdrawal for your addresses on HTX and enjoy zero service fee.',
  'Min Withdrawal Amount (excluding fee): 1 USDT (TRC20).',
  'To ensure the safety of your funds, your withdrawal request may require account verification or password confirmation.',
]

const formatNetworkTitle = ({ name, chain }) =>
  chain ? `${name} (${chain})` : name

const WithdrawOverview = () => {
  const navigate = useNavigate()
  const { exchangeWallets = [] } = useSelector((state) => state?.walletReducer)
  const { clientData } = useSelector((state) => state?.Profile)
  const { referenceCurrency } = useSelector(state => state.assets)
  const [loadingPin, setLoadingPin] = useState(false)
  const [loadingVerify, setLoadingVerify] = useState(false)
  const [feesAmount, setFeesAmount] = useState(0)
  const [selectedWallet, setSelectedWallet] = useState(null)
  const [address, setAddress] = useState('')
  const [amount, setAmount] = useState('')
  const [visibleConfirmModal, setVisibleConfirmModal] = useState(false)
  const [visibleSecurityModal, setVisibleSecurityModal] = useState(false)
  const [isRiskAccepted, setIsRiskAccepted] = useState(false)
  const [emailCode, setEmailCode] = useState('')
  const [selectedNetwork, setSelectedNetwork] = useState('')
  const selectedNetworkData = selectedWallet?.networks?.find((network) => network?._id === selectedNetwork)
  const feeValue = selectedNetworkData ? Number(selectedNetworkData.fee.split(' ')[0]) || 0 : 0
  const amountValue = Number(amount) || 0
  const receiveValue = Math.max(amountValue - feeValue, 0)
  const minimumAmount = selectedNetworkData
    ? Number(selectedNetworkData.minimum.split(' ')[0]) || 0
    : 0
  const selectedWalletBalance = Number(selectedWallet?.balance) || 0
  const isAmountAboveBalance = amount !== '' && amountValue > selectedWalletBalance
  const amountError = isAmountAboveBalance
    ? `Amount can not be greater than ${selectedWalletBalance}`
    : ''
  const isWithdrawEnabled =
    Boolean(selectedWallet) &&
    Boolean(selectedNetwork) &&
    address.trim().length > 0 &&
    amount !== '' &&
    amountValue > 0 &&
    amountValue >= minimumAmount;
  // const fakeWallets = [
  //   {
  //     _id: 'wallet1',
  //     asset: 'USDT',
  //     balance: '1000',
  //     subUid: "213213",
  //     assetId: {
  //       symbol: 'USDT'
  //     }
  //   },
  //   {
  //     _id: 'wallet2',
  //     asset: 'TRC20',
  //     balance: '200',
  //     assetId: {
  //       symbol: 'TRC20'
  //     },
  //     subUid: "213214"
  //   },
  // ]
  const wallets =  useMemo(
    () =>
      exchangeWallets.filter(
        (wallet) => wallet?.subUid && Number(wallet?.balance) > 0
      ),
    [exchangeWallets]
  )

  const handleOpenConfirmModal = () => {
    if (!isWithdrawEnabled) return
    setIsRiskAccepted(false)
    setVisibleConfirmModal(true)
  }

  const handleOpenSecurityModal = async () => {
    if (!isRiskAccepted) return
    // setLoadingPin(true)
    const res = await sendWithdrawalEmailPinAPI({ email: clientData?.email?.toLowerCase() || "m.salah@yopmail.com" })
    if (res.status) {
      setVisibleConfirmModal(false)
      setEmailCode('')
      setVisibleSecurityModal(true)
      setLoadingPin(false)
    } else {
      setLoadingPin(false)
    }
  }

  const handleCloseSecurityModal = () => {

    setVisibleSecurityModal(false)
  }

  const handleSubmitSecurityForm = async () => {
    setLoadingVerify(true)
    const res = await withdrawalEmailVerifyPinAPI({
      emalPin: emailCode
    })
    if (res.status) {
      setVisibleSecurityModal(false)
      setLoadingVerify(true)
      navigate('/withdraw-details/sadasdasd')
    } else {
      setLoadingVerify(true)
    }
  }
  console.log("selected wallet", selectedWallet);
  const handleCalculateFeesValue = (value) => {
    let fee = 0
    value = Number(value)
    const tradingFee = clientData?.transactionFeeId
    if (tradingFee?.isPercentage) {
      if (tradingFee?.assets?.[selectedWallet?.asset?.toUpperCase()]) {
        let feeValue = (tradingFee?.assets?.[selectedWallet?.asset?.toUpperCase()]?.value / 100) * value
        if (feeValue > Number(tradingFee?.assets?.[selectedWallet?.asset?.toUpperCase()]?.maxValue)) {
          fee = Number(tradingFee?.assets?.[selectedWallet?.asset?.toUpperCase()]?.maxValue)
        } else if (feeValue < Number(tradingFee?.assets?.[selectedWallet?.asset?.toUpperCase()]?.minValue)) {
          fee = Number(tradingFee?.assets?.[selectedWallet?.asset?.toUpperCase()]?.minValue)
        } else {
          fee = feeValue
        }
      } else {
        let feeValue = (tradingFee?.value?.$numberDecimal / 100) * value
        if (feeValue > Number(tradingFee?.maxValue?.$numberDecimal)) {
          fee = Number(tradingFee?.maxValue?.$numberDecimal)
        } else if (feeValue < Number(tradingFee?.minValue?.$numberDecimal)) {
          fee = Number(tradingFee?.minValue?.$numberDecimal)
        } else {
          fee = feeValue
        }
      }
    } else {
      if (tradingFee?.assets?.[coin?.asset?.toUpperCase()]) {
        if (value > tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.maxValue) {
          fee = tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.maxValue
        } else if (value < tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.minValue) {
          fee = tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.minValue
        } else {
          fee = tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.value
        }
      } else {
        if (value > tradingFee?.maxValue?.$numberDecimal) {
          fee = tradingFee?.maxValue?.$numberDecimal
        } else if (value < tradingFee?.minValue?.$numberDecimal) {
          fee = tradingFee?.minValue?.$numberDecimal
        } else {
          fee = tradingFee?.value?.$numberDecimal
        }
      }
    }

    setFeesAmount(fee)
  }
  useEffect(() => { 
    handleCalculateFeesValue(selectedWallet?.balance || 0);
  }, [selectedWallet])

  return (
    <>
      <div className={styles.page}>
        <div className={styles.panel}>
          <div className={styles.columns}>
            <section className={styles.section}>
              <div className={styles.sectionHeader}>
                <span className={styles.step}>1</span>
                <h2 className={styles.title}>Select wallet</h2>
              </div>

              <div className={styles.selectWrap}>
                <select
                  className={styles.coinSelect}
                  value={selectedWallet?.asset}
                  onChange={(e) => {
                    const wallet = wallets.find(w => w.asset.toLocaleUpperCase() === e.target.value.toUpperCase());
                    const selectedCurrency = referenceCurrency?.data?.find(
                      curr => curr?.currency?.toUpperCase() === wallet?.asset?.toUpperCase()
                    );
                    const networks = !selectedCurrency ? [] : selectedCurrency?.chains?.map(network => ({
                      _id: `${network?.displayName}-${network?.chain}-${Math.floor(Math.random() * 1000)}`,
                      name: network?.displayName,
                      chainId: {
                        _id: `${network?.displayName}-${network?.chain}-${Math.floor(Math.random() * 1000)}`,
                        name: network?.displayName,
                        cryptoapiName: network?.chain,
                        ...network
                      },
                      address: network?.address || ''
                    }))
                    console.log("onChange select wallet", {
                      wallets,
                      wallet,
                      referenceCurrency,
                      selectedCurrency,
                      networks, 
                      clientData,
                      value: e.target.value
                    });
                    handleCalculateFeesValue(wallet?.balance || 0);
                    setSelectedWallet({
                      ...wallet,
                      networks
                    });
                  }}
                >
                  {wallets.length === 0 ? (
                    <option value="">No wallets available</option>
                  ) : (
                    <>
                      <option value="">Select Wallet</option>
                      {wallets.map((wallet) => {
                          return (
                          <option key={wallet.asset} value={wallet.asset}>
                            {wallet.asset} - Balance: {wallet?.balance}
                          </option>
                        )
                      })}
                    </>
                  )}
                </select>
                <span className={styles.chevron} />
              </div>
              {selectedWallet && (
                <>

                  <div className={styles.coinCard}>
                    <div className={styles.infoRow}>
                      <span>Selected wallet</span>
                      <strong>{selectedWallet?.asset?.toUpperCase() || 'Wallet'}</strong>
                    </div>
                    <div className={styles.infoRow}>
                      <span>Available balance</span>
                      <strong>{selectedWallet?.balance || 0}</strong>
                    </div>
                    <div className={styles.infoRow}>
                      <span>Wallet ID</span>
                      <strong>{selectedWallet?._id}</strong>
                    </div>
                  </div>

                  <div className={styles.balanceRow}>
                    <div>
                      <p className={styles.balanceLabel}>Withdrawable</p>
                      <strong className={styles.balanceValue}>
                        {selectedWallet?.balance || 0} {selectedWallet?.asset?.toUpperCase() || "Wallet"}
                      </strong>
                    </div>
                    <button type="button" className={styles.linkButton}>
                      Apply for increase amount
                    </button>
                  </div>
                </>
              )}

              <div className={styles.notes}>
                {notes.map((note) => (
                  <p key={note} className={styles.note}>
                    {note}
                  </p>
                ))}
              </div>
            </section>

            {!selectedWallet ? null : (
              <section className={styles.section}>
                <div className={styles.sectionHeader}>
                  <span className={styles.step}>2</span>
                  <h2 className={styles.title}>Withdrawal Details</h2>
                </div>

                {selectedWallet.networks.length === 0 ? (
                  <p className={styles.noNetworks}>No networks available for this wallet</p>
                ) :
                  (
                    <>
                      <p className={styles.label}>Withdrawal Network</p>
                      <div className={styles.networkGrid}>
                        {
                          selectedWallet.networks.map((network) => {
                            const active = network._id === selectedNetwork

                            return (
                              <button
                                key={network._id}
                                type="button"
                                className={`${styles.networkCard} ${active ? styles.networkCardActive : ''}`}
                                onClick={() => setSelectedNetwork(network._id)}
                              >
                                <div className={styles.networkHead}>
                                  <span className={styles.radio}>
                                    <span className={styles.radioDot} />
                                  </span>
                                  <span className={styles.networkTitle}>
                                    {formatNetworkTitle(network)}
                                  </span>
                                </div>
                                <p className={styles.networkText}>Fee {network?.fee}</p>
                                <p className={styles.networkText}>
                                  Minimum Withdrawal {network?.minimum}
                                </p>
                                <p className={styles.networkText}>Arrival Time {network?.arrival}</p>
                              </button>
                            )
                          })
                        }
                      </div>
                    </>
                  )}
                <div className={styles.formBlock}>
                  <div className={styles.fieldBlock}>
                    <div className={styles.fieldHeader}>
                      <span className={styles.fieldLabel}>Address</span>
                      <button type="button" className={styles.fieldLink}>
                        Withdrawal Address
                      </button>
                    </div>
                    <div className={styles.inputShell}>
                      <input
                        type="text"
                        className={styles.textInput}
                        placeholder="Enter withdrawal address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                      <div className={styles.inputActions}>
                        <button
                          type="button"
                          className={styles.clearAction}
                          onClick={() => setAddress('')}
                        >
                          x
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={styles.fieldBlock}>
                    <span className={styles.fieldLabel}>Withdrawal Amount</span>
                    <div className={styles.amountShell}>
                      <input
                        type="number"
                        min={minimumAmount}
                        max={selectedWalletBalance || undefined}
                        className={styles.amountInput}
                        placeholder={selectedNetworkData ? `MIN ${minimumAmount}` : 'MIN 0'}
                        value={amount}
                        onChange={(e) => { 
                          setAmount(e.target.value);
                          handleCalculateFeesValue(e.target.value); 
                        }}
                      />
                      <span className={styles.amountUnit}>
                        {selectedWallet?.asset?.toUpperCase() || 'USDT'}
                      </span>
                      <button
                        type="button"
                        className={styles.amountLink}
                        onClick={() => setAmount(selectedWallet?.balance || '')}
                      >
                        All
                      </button>
                    </div>
                    {!amountError ? null : (
                      <p className={styles.fieldError}>{amountError}</p>
                    )}
                  </div>

                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Fee</span>
                    <span className={styles.infoValue}>
                      {feesAmount ? feesAmount : 0}
                    </span>
                  </div>

                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>You Receive</span>
                    <span className={styles.infoValue}>
                      {selectedWallet?.balance || 0} {selectedWallet?.asset?.toUpperCase() || 'USDT'}
                    </span>
                  </div>

                  <button
                    type="button"
                    className={`${styles.withdrawButton} ${isWithdrawEnabled ? styles.withdrawButtonActive : ''}`}
                    disabled={!isWithdrawEnabled}
                    onClick={handleOpenConfirmModal}
                  >
                    Withdraw
                  </button>
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
      <ConfirmWithdrawModal
        visible={visibleConfirmModal}
        onClose={() => setVisibleConfirmModal(false)}
        address={address}
        assetSymbol={selectedWallet?.asset?.toUpperCase() || 'USDT'}
        receiveValue={receiveValue}
        amountValue={amountValue}
        feeValue={feeValue}
        isRiskAccepted={isRiskAccepted}
        onRiskChange={setIsRiskAccepted}
        onConfirm={handleOpenSecurityModal}
        loadingPin={loadingPin}
      />
      <SecurityAuthModal
        visible={visibleSecurityModal}
        onClose={handleCloseSecurityModal}
        onSubmit={handleSubmitSecurityForm}
        emailCode={emailCode}
        onEmailCodeChange={setEmailCode}
        loadingVerify={loadingVerify}
      />
    </>
  )
}

export default WithdrawOverview
